<template>
  <qx-card title="列表">
    <LogRightDialog
      ref="logRightDialog"
      busiCode="600010"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="1004040601">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop ==='mobilePhone'"
            >
              <section  slot-scope="scope">
                <section v-if="scope.column.property === 'bindCard'">
                  <template v-if="checkPermpisions('1004040604')">
                    <span class="primary cur" @click="toBankcard(scope.row)">{{scope.row.bindCard ? '已绑定' : '未绑定'}}</span>
                  </template>
                </section>
                <section v-else>{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="140">
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1004040602',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row.relId),
                  },
                  {
                    permpisions: '1004040603',
                    showCondition: true,
                    name: '移除',
                    event: () => del(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.relId),
                  },
                ]"
              />
              <!-- <section>
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="toEdit(scope.row.relId)">修改</span>
                </qx-permpisions>
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="del(scope.row)">移除</span>
                </qx-permpisions>
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showLog(scope.row.relId)">日志</span>
                </qx-permpisions>
              </section> -->
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  receipertList,
  receipertDetail,
  receipertDel,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'mobilePhone',
            label: '手机号码',
          },
          {
            prop: 'linkman',
            label: '姓名',
          },
          {
            prop: 'receiverName',
            label: '收款名称',
          },
          {
            prop: 'remark',
            label: '备注',
          },
          {
            prop: 'bindCard',
            label: '银行卡',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: receipertList,
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    async toBankcard (item) {
      const res = await receipertDetail({
        relId: item.relId,
      });
      this.jump({
        label: '银行卡信息',
        url: `/manage/other/bankcard?userId=${res.userDataInfo.userId}&receipt=true`,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '收款人',
        url: `/manage/getPay/account/receipt/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    async del (item) {
      const confirmRes = await this.$confirm('是否确认移除该账号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await receipertDel({
          relId: item.relId,
        });
        if (!res.failed) {
          this.$message.success('移除成功');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
